import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { createClient } from '@/api/supabase'
import { USE_MOCK } from '@/config'

/**
 * Подписка на UPDATE по `public.profiles WHERE role='inspector'`. Любое
 * изменение инвалидирует ВСЕ запросы `['inspectors-positions', ...]` —
 * текущая страница перезапросится сама. Если строка вне окна пагинации —
 * обновление не «дойдёт» до пользователя, это допустимо для отладочного
 * экрана (в ТЗ так и указано).
 *
 * Канал поднимается на время монтирования страницы (не singleton, как
 * useOrdersRealtime), чтобы не держать webhook'и когда экрана нет.
 *
 * Требует: ALTER PUBLICATION supabase_realtime ADD TABLE public.profiles
 * (миграция `20260504010000_realtime_profiles.sql`).
 */
export function useInspectorsPositionsRealtime() {
  const qc = useQueryClient()

  useEffect(() => {
    if (USE_MOCK) return
    const supabase = createClient()

    let cancelled = false
    let cleanup: (() => void) | null = null

    void (async () => {
      // Дожидаемся сессии — иначе RLS отбросит публикации, канал закроется.
      const { data } = await supabase.auth.getSession()
      if (cancelled) return
      if (data.session) {
        supabase.realtime.setAuth(data.session.access_token)
      }

      const channel = supabase
        .channel('inspectors-positions')
        .on(
          'postgres_changes',
          {
            event: 'UPDATE',
            schema: 'public',
            table: 'profiles',
            filter: 'role=eq.inspector',
          },
          () => {
            void qc.invalidateQueries({ queryKey: ['inspectors-positions'] })
          },
        )
        .subscribe()

      cleanup = () => {
        void supabase.removeChannel(channel)
      }
    })()

    return () => {
      cancelled = true
      cleanup?.()
    }
  }, [qc])
}
